import { jsonBinAxios } from '../httpInstance/jsonBinAxios'

export const updateQRCodeInfo = async data => {
    const url = `/auth/store/`

    try {
        const response = await jsonBinAxios.post(url, { data })
        if (response.data.success) {
            return { data: response.data.request_id }
        }
    } catch (error) {
        console.log('error in updating qr code info :- ', error)
        throw error
    }
}
